import { usePath } from '@/hooks/usePath';
import Menu, { type MenuProps } from '@/components/Menu';
import Title from '@/components/Title';
import ScanServicesList from '@/components/ScanServicesList';
import { PENDING_FILTER } from './constants';
import { classes } from './utils';

export interface PendingServicesMenuProps extends MenuProps {
  serviceIds: number[];
}

export default function PendingServicesMenu({
  open,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  serviceIds,
  onClose,
}: PendingServicesMenuProps) {
  const { navigate } = usePath();

  const handleViewAll = () => {
    navigate('/dashboard/scan-services/', {
      filters: PENDING_FILTER,
    });
    onClose();
  };

  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      className={classes.menu}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      <div className={classes.header}>
        <Title className={classes.title} size="sm">
          Scan Services
        </Title>
        <div className={classes.buttonsWrapper}>
          <button className={classes.button} onClick={handleViewAll}>
            View all
          </button>
        </div>
      </div>
      {serviceIds.length > 0 ? (
        <ScanServicesList
          wide
          className={classes.list}
          serviceIds={serviceIds}
          onOpen={() => onClose()}
        />
      ) : (
        <div className={classes.emptyMessage}>No pending services</div>
      )}
    </Menu>
  );
}
